import { c as _c } from "react/compiler-runtime";
import type { CommonProps } from '@mui/material/OverridableComponent';
import type { SxProps, Theme } from '@mui/material';
import { Horizontal } from './Horizontal';
import { Vertical } from './Vertical';
import type { FadedEdgesBoxProps } from './types';

/**
 *
 * Regular box with faded edges that will make scrollings more noticeable and smooth.
 *
 * It requires a container with `position: relative` CSS property in order to define scope,
 * otherwise it'll take the first found relative parent as reference.
 *
 */
export function FadedEdgesContainer(props) {
  const $ = _c(6);
  let rest;
  let t0;
  if ($[0] !== props) {
    ({
      orientation: t0,
      ...rest
    } = props);
    $[0] = props;
    $[1] = rest;
    $[2] = t0;
  } else {
    rest = $[1];
    t0 = $[2];
  }
  const orientation = t0 === undefined ? "horizontal" : t0;
  const isHorizontal = orientation === "horizontal";
  let t1;
  if ($[3] !== isHorizontal || $[4] !== rest) {
    t1 = isHorizontal ? <Horizontal {...rest} /> : <Vertical {...rest} />;
    $[3] = isHorizontal;
    $[4] = rest;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
}